import {
  InquiryCount,
  InquiryFetchArgs,
  getInquiryCount,
} from '../../assets/ts/data/inquiry/inquiry'
import useServerData from '../use-server-data'

function useInquiryCount(fetchArgs: InquiryFetchArgs) {
  const {
    data: inquiryCount,
    error: inquiryCountError,
    fetchData: fetchInquiryCount,
    isLoading: inquiryCountIsLoading,

  } = useServerData<InquiryCount, InquiryFetchArgs>(
    getInquiryCount,
    fetchArgs
  )

  const count = inquiryCount?.[0]?.InquiryGUID_count ?? 0
  return {
    fetchInquiryCount,
    inquiryCount, // retained for backward-compatibility.  Use inquiryCountValue
    inquiryCountError,
    inquiryCountIsLoading,
    inquiryCountValue: count,
  }
}

export default useInquiryCount
